import { useMutation } from "@apollo/client/react";
import {
  CreateChatMessageMutation,
  CreateChatMessageMutationVariables,
  FetchChatMessagesByEntityIdQuery,
  FetchChatMessagesByEntityIdQueryVariables,
  CreateChatMessageDocument,
  FetchChatMessagesByEntityIdDocument,
} from "@/graphql/__generated__/graphql";

export default function useCreateChatMessageMutationHook(): { createChatMessageMutation: any, loading: any, error: any } {
  const [createChatMessageMutation, { loading, error }] = useMutation<CreateChatMessageMutation, CreateChatMessageMutationVariables>(
    CreateChatMessageDocument,{
      update(cache, { data }) {
        if (!data?.createChatMessage) return;

        try {
          const newMessage = data.createChatMessage;

          // Update the chat messages cache
          cache.updateQuery<FetchChatMessagesByEntityIdQuery, FetchChatMessagesByEntityIdQueryVariables>(
            {
              query: FetchChatMessagesByEntityIdDocument,
              variables: {
                entityId: newMessage.entityId,
                type: newMessage.type,
              },
            },
            (prev) => {
              if (!prev?.fetchChatMessagesByEntityId) return prev;

              // Return a new state where we append the new message
              return {
                ...prev,
                fetchChatMessagesByEntityId: [
                  ...prev.fetchChatMessagesByEntityId,
                  newMessage
                ]
              };
            }
          );

          // Update the tender's totalMessages count using cache.modify
          // This works regardless of which query fetched the tender
          cache.modify({
            id: cache.identify({ __typename: "Tender", id: newMessage.entityId }),
            fields: {
              totalMessages(existingCount = 0) {
                return existingCount + 1;
              }
            }
          });
        } catch (err) {
          console.error("Cache update failed:", err);
        }
      }
    });

  return {
    createChatMessageMutation,
    loading,
    error
  };
}
